import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'styles/index.scss';
import 'localization/i18ts';
import { ApolloProvider } from '@apollo/client';
import { client } from 'graphqlapi';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import ReactPWAInstallProvider from 'react-pwa-install';
import { theme } from 'utils';
import {ThemeProvider} from "@material-ui/core/styles";

ReactDOM.render(
	<React.StrictMode>
		<ApolloProvider client={client}>
			<ThemeProvider theme={theme}>
				<ReactPWAInstallProvider>
					<App/>
				</ReactPWAInstallProvider>
			</ThemeProvider>
		</ApolloProvider>
	</React.StrictMode>,
	document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
